<template>
  <div class="lifestages">
      <IntroWithInfo
        :title="intro.title"
        :intro="intro.intro"
        :info="intro.info"
      />

      <div class="lifestages__stages">
        <section class="lifestages__stage lifestages__stage--first" v-on:click="open">
          <div class="lifestages__stage-header">
            <h3 class="lifestages__stage-title">
              Startfas
            </h3>
            <p class="lifestages__stage-title lifestages__stage-title--range">
              0 - 25 år
            </p>
          </div>

          <p class="lifestages__stage-text">
            I början av livet då vi är mellan 0-25 år är det inte många som tänker på försäkringar eller pension. Men faktum är att det redan nu de första byggstenarna börjar läggas. Dels genom en fördelaktig barnförsäkring dina målsägande valt åt dig och senare när du börjar ta dina allra första karriärsteg.
          </p>
        </section>

        <section class="lifestages__stage lifestages__stage--second">
          <div class="lifestages__stage-header" v-on:click="open">
            <h3 class="lifestages__stage-title">
              Uppbyggnadsfas
            </h3>
            <p class="lifestages__stage-title lifestages__stage-title--range">
              25 - 50 år
            </p>
          </div>
          <p class="lifestages__stage-text">
            Genom hela vårt yrkesliv och i åldrarna 25-50 år bygger vi upp vår pension. Det är den allmänna pensionen, eventuell tjänstepension och ditt egna sparande som påverkar din pension. Utöver det påverkar  även din sjukförsäkring och eventuell sjukvårdsförsäkring som du har via din arbetsgivare.
          </p>
        </section>

        <section class="lifestages__stage lifestages__stage--third">
          <div class="lifestages__stage-header" v-on:click="open">
            <h3 class="lifestages__stage-title">
              Förvaltningsfas
            </h3>
            <span class="lifestages__stage-title lifestages__stage-title--range">
              50 - 65 år
            </span>
          </div>
          <p class="lifestages__stage-text">
            När vi närmar oss pension i åldrarna 50-65 år är det bra att göra en kvalitativ förvaltning av din pension och dina tillgångar. Det kan behövas vidtas åtgärder för att din pension ska bli så bra som möjligt och för att få pengarna att räcka livet ut. Det kan till exempel handla om att minska riskerna i ditt sparande för att på så sätt säkra ditt sparkapital.
          </p>
        </section>

        <section class="lifestages__stage lifestages__stage--fourth">
          <div class="lifestages__stage-header" v-on:click="open">
            <h3 class="lifestages__stage-title">
              Uttagsfas
            </h3>
            <span class="lifestages__stage-title lifestages__stage-title--range">
              65 år och framåt
            </span>
          </div>
          <p class="lifestages__stage-text">
            När du väl har nått pensionsåldern 65 år och framåt är det bra om du har sparat ihop till en pension som du klarar dig på varje månad och som du kan leva gott på livet ut. Om du behöver mer pengar att röra dig med kan man titta närmare på åtgärder såsom återbetalningsskydd, jobba längre eller extra som pensionär och att hyra ut eventuella fastigheter och tillgångar när de inte används, till exempel båten eller sommarstugan.
          </p>
        </section>
      </div>
  </div>
</template>

<script>
import IntroWithInfo from '../elements/Info/IntroWithInfo.vue';

export default {
  name: 'LifeStages',
  components: { IntroWithInfo },
  data() {
    return {
      intro: {
        title: "Dina livsfaser",
        intro: "För att lättare kunna planera din pension kan du utgå från livets olika faser, dessa faser kan guida dig till hur du strategiskt kan tänka inför och under ditt pensionssparande.",
        info: {
          title: "Information om livsfaserna",
          text: "En människas liv utgörs av ett antal faser, som bildar en livscykel som består av liknande mönster som alla leder till pensionen. Det finns såklart många olikheter men dessa faser är de vanligaste i vårt samhälle idag. Att vara medveten om dessa faser gör en bättre förberedd på framtiden och hur man vill leva som pensionär. Man kan därmed ta smartare beslut kring sin framtida pension i en tidig livsfas. Vi lever som vi alla vet i en snabb interaktiv värld där man allt mer skall fokusera på nuet så att kunna planera långt fram i tiden (där pensionen ofta finns) är något både läskigt och inte allt för vanligt. Därför har vi beskrivit livets olika faser nedan så att du kan planera din pension mer strategiskt."
        },
      },
    }
  },
  methods: {
    open (e) {
      let parent = e.target.parentElement // Gets parent sibling accurately from both h3 and p
      let element = parent.nextElementSibling

      if(element != null) {
        element.classList.toggle('lifestages--active-text')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lifestages {
  margin: 2rem;

  &--active-text {
    padding: 1.5rem !important;
    height: 100% !important;
  }

  &__stages {
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-top-left-radius: $borderRadius;
    border-top-right-radius: $borderRadius;
    overflow: hidden;
  }

  &__stage {
    float: left;

    &-title {
      color: black;
      text-transform: none;
      font-size: 1rem;
      display: flex;
      flex-direction: column;
      padding: 1.5rem 1.5rem 0 1.5rem;

      &--range {
        font-family: "Roboto", sans-serif;
        font-weight: normal;
        padding: 0;
        padding: 0 1.5rem 1.5rem 1.5rem;
      }
    }

    &-text {
      color: black;
      font-weight: normal;
      height: 0;
      overflow: hidden;
      padding: 0 1.5rem;
      transition: all .3s ease-in-out;
      pointer-events: none;
    }

    &--first {
      background-color: #76b190;
      width: 100%;

      .lifestages__stage {
        &-text {
          background-color: rgb(207, 238, 220)
        }
      }
    }

    &--second {
      background-color: #ffb25b;
      width: 100%;

      .lifestages__stage {
        &-text {
          background-color: rgb(255, 216, 172);
        }
      }
    }

    &--third {
      background-color: #e78961;
      width: 100%;

      .lifestages__stage {
        &-text {
          background-color: #f1b094;
        }
      }
    }

    &--fourth {
      background-color: #5c8fa7;
      width: 100%;

      .lifestages__stage {
        &-text {
          background-color: rgb(164, 209, 230);
        }
      }
    }
  }

  @include breakpoints(large) {
    &__stages {
      display: block;
    }

    &__stage {
      &--first {
        width: 28%;
      }

      &--second {
        width: 28%;
      }

      &--third {
        width: 20%;
      }

      &--fourth {
        width: 24%;
      }
    }
  }
}
</style>